module.exports = __webpack_public_path__ + "img/alice_tenniel_ost.c8c54cb1.png";